import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { TemplateRequestStatus } from '../../FormChangeHistory.constants';
import { getPartsSubtitle, getTemplatePartGroups } from '../../FormChangeHistory.utils';
import useTemplateChanges from '../../hooks/useTemplateChanges';

/** "7 parts in 4 groups", once the Prism change's parts have loaded; the read is shared. */
const PrismPartsCount = ({ change, detail }) => {
  const { status, data } = useTemplateChanges({ change, detail });

  const groups = useMemo(() => getTemplatePartGroups(data?.parts), [data]);

  return status === TemplateRequestStatus.LOADED && groups.length > 0
    ? getPartsSubtitle(groups)
    : null;
};

PrismPartsCount.propTypes = {
  change: PropTypes.shape({ summary: PropTypes.object }).isRequired,
  detail: PropTypes.shape({ summary: PropTypes.object.isRequired }).isRequired,
};

export default PrismPartsCount;
